module.exports = __webpack_public_path__ + "img/product-preview-69.6843f61.png";